"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * window操作ユーティリティ
 */

let headerHeight = 50;
const dialogPaddingTop = 24;

/**
 * 渡された位置にスクロールするまでスクロールし続ける(10ミリ秒ごと10回まで)
 *
 * @param {number} scrollTop - 移動先スクロール位置
 */
const windowScroll = scrollY => {
  let count = 0;
  const scroll = () => {
    if (count >= 10) {
      return;
    }
    window.scrollTo(0, scrollY);
    setTimeout(() => {
      if (window.scrollY < scrollY - 5 || window.scrollY > scrollY + 5) {
        scroll();
      }
    }, 10);
    count++;
  };
  scroll();
};

/**
 * 渡された要素の上にスクロールする
 *
 * @param {element} element - 要素
 * @param {bool} isNewWindow - 別ウィンドウ等のヘッダーのない機能の場合trueを指定する（headerHeightを0にする）
 */
const scrollAboveElement = (element, isNewWindow) => {
  if (!element || !element.getBoundingClientRect) {
    return;
  }
  const rect = element.getBoundingClientRect();
  if (isNewWindow) {
    headerHeight = 0;
  }

  // ヘッダ要素分マイナス
  windowScroll(window.scrollY + rect.top - headerHeight);
};

/**
 * 渡された要素を左上に上にスクロールする
 *
 * @param {element} element - 要素
 */
const elementScrollTop = element => {
  if (!element || !element.getBoundingClientRect) {
    return;
  }
  element.scrollTo(0, 0);
};

/**
 * 渡された要素の下にスクロールする
 *
 * @param {element} element - 要素
 * @param {bool} isNewWindow - 別ウィンドウ等のヘッダーのない機能の場合trueを指定する（headerHeightを0にする）
 */
const scrollBelowElement = (element, isNewWindow) => {
  if (!element || !element.getBoundingClientRect) {
    return;
  }
  const rect = element.getBoundingClientRect();
  if (isNewWindow) {
    headerHeight = 0;
  }

  // ヘッダ要素分マイナス
  windowScroll(window.scrollY + rect.top + rect.height - headerHeight);
};

/**
 * 渡された要素の下にスクロールする
 *
 * @param {element} element - 要素
 * @param {element} area - 表示領域
 */
const scrollBelowDialogElement = (element, area) => {
  if (!element || !element.getBoundingClientRect) {
    return;
  }
  if (!area || !area.scrollTo) {
    return;
  }
  //ダイアログコンテンツのpaddingTop分プラス
  area.scrollTo(0, element.getBoundingClientRect().height + dialogPaddingTop);
};
var _default = exports.default = Object.freeze({
  windowScroll,
  scrollAboveElement,
  elementScrollTop,
  scrollBelowElement,
  scrollBelowDialogElement
});